interface PagerProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}

const BUTTON_CLASS = "border-none padding-0 text-color-gray text-size-14 cursor-pointer";
const BUTTON_STYLE = { background: "none" } as const;

export default function Pager({ currentPage, totalPages, onPageChange, className = "" }: Readonly<PagerProps>) {
  const isFirst = currentPage <= 1;
  const isLast = currentPage >= totalPages;

  return (
    <div className={`display-flex justify-content-center ${className}`.trim()}>
      <div className="display-flex flex-column min-width-150">
        <div className="display-flex align-items-center justify-content-center gap-10 margin-bottom-10">
          <button
            type="button"
            data-testid="pager-anterior"
            className={BUTTON_CLASS}
            style={BUTTON_STYLE}
            disabled={isFirst}
            onClick={() => onPageChange(currentPage - 1)}
          >
            <span className="rioglyph rioglyph-chevron-left" aria-hidden="true" />
          </button>
          <span className="text-color-gray text-size-14">
            {currentPage} / {totalPages}
          </span>
          <button
            type="button"
            data-testid="pager-proxima"
            className={BUTTON_CLASS}
            style={BUTTON_STYLE}
            disabled={isLast}
            onClick={() => onPageChange(currentPage + 1)}
          >
            <span className="rioglyph rioglyph-chevron-right" aria-hidden="true" />
          </button>
        </div>
        <div className="progress height-3">
          <div
            className="progress-bar progress-bar-primary"
            style={{ width: `${(currentPage / totalPages) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
}
